
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nepal",
      function () {
        return require("private-next-pages/nepal.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nepal"])
      });
    }
  